import styled, { css } from 'styled-components';
import { Text } from '@lmn/design-system';
import { ellipsis } from '@/app/components/search/styles/mixins.ts';
import {
  trustYouExcellent,
  trustYouFair,
  trustYouGood,
  trustYouPoor,
  trustYouVeryGood,
} from '../../../../styles/colors';

export const RatingsContainer = styled.div<{ isOverlay: boolean }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  color: ${({ theme }) => theme.kallisto.color.text.static.textSecondary};
  max-width: 100%;

  ${({ isOverlay }) => {
    if (isOverlay) {
      return css`
        margin-bottom: 4px;
      `;
    }

    return css`
      margin-bottom: 8px;
    `;
  }}
`;

export const Separator = styled.div<{ height?: number; asBr?: boolean }>`
  width: 1px;
  background-color: ${({ theme }) => theme.kallisto.color.common.black[100]};
  height: 20px;
  margin: 0 8px;

  ${({ height }) => {
    if (height) {
      return css`
        height: ${height}px;
        margin: 0 6px;
      `;
    }

    return css``;
  }}
`;

export const Score = styled(Text)`
  border-radius: 4px;
  color: ${({ theme }) => theme.kallisto.color.background.static.backgroundPage};
  height: 20px;
  min-width: 30px;
  padding: 2px 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 8px;
  letter-spacing: 0.01em;

  &.no-rating {
    background: #dadada;
  }

  &.excellent {
    background: ${trustYouExcellent};
  }

  &.very-good {
    background: ${trustYouVeryGood};
  }

  &.good {
    background: ${trustYouGood};
  }

  &.pleasant {
    background: ${trustYouFair};
  }

  &.poor {
    background: ${trustYouPoor};
  }
`;

export const ReviewsNumber = styled(Text)`
  ${ellipsis};
`;

export const ReviewsTitle = styled(Text)`
  white-space: nowrap;
`;
